import{LuciadError}from"./LuciadError";export class ProgrammingError extends LuciadError{constructor(r){super(r);this.name="luciad.error.ProgrammingError"}}